import type { GetProjects200PageAllOfThreeContentItemBasicInfoVisibility } from './getProjects200PageAllOfThreeContentItemBasicInfoVisibility';

/**
 * 프로젝트 기본 정보
 */
export type GetProjects200PageAllOfThreeContentItemBasicInfo = {
  createdAt?: string;
  description?: string;
  /** 프로젝트 ID (Snowflake ID) */
  id?: number;
  title?: string;
  updatedAt?: string;
  visibility?: GetProjects200PageAllOfThreeContentItemBasicInfoVisibility;
};
